<template>
  <div class="flex justify-start items-center gap-1">
    <template v-for="(item, index) in items" :key="index">
      <!-- Label -->
      <span
        class="text-xs font-semibold text-nowrap cursor-pointer"
        :class="item.active ? 'text-gray-800' : 'text-red-600'"
        @click="item.to && $router.push({ path: item.to, query: item.query })"
      >
        {{ item.label }}
      </span>

      <!-- Separator -->
      <i
        v-if="index < items.length - 1"
        class="mdi mdi-chevron-right text-xl"
      ></i>
    </template>
  </div>
</template>

<script>
export default {
  name: "BreadcrumbComponent",
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
};
</script>
